//Types
export const Types = {
  CREATE_COLLECTION: "CREATE_COLLECTION",
  UPDATE_COLLECTION: "UPDATE_COLLECTION",
  GET_COLLECTION: "GET_COLLECTION",
  GET_COLLECTIONS: "GET_COLLECTIONS",
  DELETE_COLLECTION: "DELETE_COLLECTION",
  DELETE_COLLECTION_CARGA: "DELETE_COLLECTION_CARGA",
  VERIFY_CONNECTION: "VERIFY_CONNECTION_COLLECTION",
  VERIFY_COLLECTION_ASSOCIATION: "VERIFY_COLLECTION_ASSOCIATION",
  EXECUTE_QUERY: "EXECUTE_QUERY_COLLECTION",
  SET_LOADING: "SET_LOADING_COLLECTION",
  UPLOAD_METADATA: "UPLOAD_METADATA",
  DELETE_METADATA: "DELETE_METADATA",
  CLEAR_COLLECTIONS_REGISTER: "CLEAR_COLLECTIONS_REGISTER",
  SAVE_COLLECTION_CREATION: "SAVE_COLLECTION_CREATION",
  GET_COLLECTION_USAGE: "GET_COLLECTION_USAGE",
  INACTIVATE_COLLECTION: "INACTIVATE_COLLECTION",
  REACTIVATE_COLLECTION: "REACTIVATE_COLLECTION",
  GET_PREVIEW_COLLECTION: "GET_PREVIEW_COLLECTION",
  SET_LOADING_PREVIEW: "SET_LOADING_PREVIEW",
  ADD_NEW_COLLECTION_EXECUTION: "ADD_NEW_COLLECTION_EXECUTION",
  ADD_NEW_COLLECTION_TRUNCATE: "ADD_NEW_COLLECTION_TRUNCATE",
  GET_ALL_SYSTEM_COLLECTIONS: "GET_ALL_SYSTEM_COLLECTIONS",
  GET_ALL_DOMAIN_COLLECTIONS: "GET_ALL_DOMAIN_COLLECTIONS",
  SET_LOADING_TOKEN: "SET_LOADING_TOKEN",
  GET_TOKEN: "GET_TOKEN",
  IS_COLLECTION_TOKEN_DERIVATED: "IS_COLLECTION_TOKEN_DERIVATED",
  CREATE_DIRECTORY_INGESTOR_SUCCESS: "CREATE_DIRECTORY_INGESTOR_SUCCESS",
  CREATE_DIRECTORY_INGESTOR_ERROR: "CREATE_DIRECTORY_INGESTOR_ERROR",
  UPDATE_COLLECTION_TOKEN: "UPDATE_COLLECTION_TOKEN",
  GET_PIPELINE_METADATA: "GET_PIPELINE_METADATA",
  GET_COLLECTION_MODEL: "GET_COLLECTION_MODEL",
  UPDATE_COLLECTION_MODEL: "UPDATE_COLLECTION_MODEL"
};

//Reducer
const initialState = {
  collections: null,
  collectionsUsage: null,
  collectionsSystem: null,
  collectionsDomain: null,
  collection: null,
  loading: false,
  connection: null,
  metadata: null,
  isCollectionAssociated: null,
  previewCollection: null,
  loadingPreview: false,
  token: null,
  isCollectionTokenDerivated: false,
  loadingTokenCollection: false,
  collectionMER: null
};

const Collections = (state = initialState, action) => {
  switch (action.type) {
    case Types.CREATE_COLLECTION:
      return {
        ...state,
        // collections: action.payload,
      };

    case Types.UPDATE_COLLECTION:
      return {
        ...state,
        collection: action.payload,
      };

    case Types.GET_COLLECTION:
      return {
        ...state,
        collection: action.payload,
        loading: false,
      };

    case Types.GET_COLLECTIONS:
      return {
        ...state,
        collections: action.payload,
        loading: false,
      };

    case Types.GET_COLLECTION_USAGE:
      return {
        ...state,
        collectionsUsage: action.payload,
        loading: false,
      };

    case Types.DELETE_COLLECTION:
      return {
        ...state,
        collections: action.payload,
        loading: false,
      };

    case Types.DELETE_COLLECTION_CARGA:
      return {
        ...state,
        collections: action.payload,
        loading: false,
      };

    case Types.INACTIVATE_COLLECTION:
      return {
        ...state,
        collections: action.payload,
        loading: false,
      };

    case Types.REACTIVATE_COLLECTION:
      return {
        ...state,
        collections: action.payload,
        loading: false,
      };

    case Types.VERIFY_CONNECTION:
      return {
        ...state,
        connection: action.payload,
      };

    case Types.VERIFY_COLLECTION_ASSOCIATION:
      return {
        ...state,
        isCollectionAssociated: action.payload,
      };

    case Types.EXECUTE_QUERY:
      return {
        ...state,
        metadata: action.payload,
        loading: false,
      };

    case Types.UPLOAD_METADATA:
      return {
        ...state,
        metadata: action.payload,
      };

    case Types.DELETE_METADATA:
      return {
        ...state,
        metadata: null,
      };

    case Types.CLEAR_COLLECTIONS_REGISTER:
      return initialState;

    case Types.SAVE_COLLECTION_CREATION:
      return {
        ...state,
        collections: action.payload,
      };

    case Types.GET_PREVIEW_COLLECTION:
      return {
        ...state,
        previewCollection: action.payload,
        loadingPreview: false,
      };

    case Types.ADD_NEW_COLLECTION_EXECUTION:
      return {
        ...state,
        loading: false,
      };

    case Types.ADD_NEW_COLLECTION_TRUNCATE:
      return {
        ...state,
        loading: false,
      };

    case Types.GET_ALL_SYSTEM_COLLECTIONS:
      return {
        ...state,
        collectionsSystem: action.payload,
        loading: false,
      };

    case Types.GET_ALL_DOMAIN_COLLECTIONS:
      return {
        ...state,
        collectionsDomain: action.payload,
        loading: false,
      };

    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case Types.SET_LOADING_PREVIEW:
      return {
        ...state,
        loadingPreview: true,
      };

    case Types.GET_TOKEN:
      return {
        ...state,
        token: action.payload,
        loadingTokenCollection: false,
      };

    case Types.SET_LOADING_TOKEN:
      return {
        ...state,
        loadingTokenCollection: true,
      };

    case Types.IS_COLLECTION_TOKEN_DERIVATED:
      return {
        ...state,
        isCollectionTokenDerivated: action.payload,
        loading: false,
      };

    case Types.CREATE_DIRECTORY_INGESTOR_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case Types.CREATE_DIRECTORY_INGESTOR_ERROR:
      return {
        ...state,
        loading: false,
      };

    case Types.UPDATE_COLLECTION_TOKEN:
      return {
        ...state,
        userCollection: action.payload,
      };

    case Types.UPDATE_COLLECTION_MODEL:
      return {
        ...state,
        collectionMER: action.payload,
      };

    case Types.GET_PIPELINE_METADATA:
      return {
        ...state,
        metadata: action.payload,
      };

     case Types.GET_COLLECTION_MODEL:
      return {
        ...state,
        collectionMER: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default Collections;
